module.exports = __webpack_public_path__ + "img/cassa-grey.c486c2db.svg";